var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _g, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09448 16.6641L10.7654 18.2061L5.34164 27.6003L3.78491 24.1285L8.09448 16.6641Z",
    fill: "#48722D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09448 16.6641L5.42358 15.122L-0.000167545 24.5162L3.78491 24.1285L8.09448 16.6641Z",
    fill: "#2B391C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9052 16.6641L9.23425 18.2061L14.658 27.6003L16.2147 24.1285L11.9052 16.6641Z",
    fill: "#2B391C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9052 16.6641L14.5761 15.122L19.9998 24.5162L16.2147 24.1285L11.9052 16.6641Z",
    fill: "#48722D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.91768,
    cy: 10.1954,
    r: 9.55112,
    fill: "url(#paint0_linear_2201_23829)",
    stroke: "#765C00",
    strokeWidth: 0.711458
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.91807,
    cy: 10.1935,
    r: 7.17784,
    fill: "#A88300"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2201_23829",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 15,
    height: 16
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3007,
    cy: 10.9602,
    r: 7.19454,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2201_23829)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.91757,
    cy: 10.1945,
    r: 7.19454,
    fill: "#C09525"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95668 5.19141L11.5086 8.29534L14.6126 8.68333L12.4812 11.0734L13.0606 14.5032L9.95668 12.9512L6.85275 14.5032L7.43732 11.0734L5.30078 8.68333L8.40471 8.29534L9.95668 5.19141Z",
    fill: "url(#paint1_linear_2201_23829)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2201_23829",
    x1: 9.91768,
    y1: 1,
    x2: 9.91768,
    y2: 19.3908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2201_23829",
    x1: 9.95668,
    y1: 5.19141,
    x2: 9.95668,
    y2: 14.5032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE896"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/gold_medal.db4ce0465c21c7b89c239b3ad333e0d9.svg";
export { ForwardRef as ReactComponent };